import builder from '../builders/base';

export default {
  getRules: query => builder()
    .setMethod('GET')
    .setParam('services', query.services)
    .setParam('page', query.page)
    .setParam('perPage', query.perPage)
    .setUrl('rules')
    .build(true),

  getRuleById: id => builder()
    .setMethod('GET')
    .setUrl(`rules/${id}`)
    .build(),

  updateRuleById: data => builder()
    .setMethod('PATCH')
    .setData(data)
    .setUrl('rules')
    .build(),
};



// WEBPACK FOOTER //
// ./src/services/modules/rule.js